import { Attribute, BelongsTo, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi'

import { ArrayConverter } from '../core/converters/array.converter'
import { Empresa } from '../core/empresa.model'
import { CodigoDeChamada } from './codigo-de-chamada.model'
import { CodigoDeChamadaConverter } from './converters/codigo-de-chamada.converter'

@JsonApiModelConfig({
    type: 'empresas-que-vendem-com-cartoes'
})
export class EmpresaQueVendeComCartoes extends JsonApiModel {
    @Attribute({
        converter: new ArrayConverter(new CodigoDeChamadaConverter())
    })
    codigosDeChamada: CodigoDeChamada[]

    @BelongsTo() empresa: Empresa
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/empresa-que-vende-com-cartoes.model.ts